export function destroyDxComponent(dxComponent: any, clientId: string) {
  if (dxComponent && dxComponent.instance) {
    dxComponent.instance.dispose();
    dxComponent = null;
    var doc = document.getElementById(clientId);
    if (doc) doc.remove();
  }
}
